<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">ការទូទាត់ប្រាក់</h4>
					</md-card-header>
					<md-card-content>
						<router-view />
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Payments.vue